export const API_URL = process.env.REACT_APP_API_URL || "https://repox-store-api-development.dev.datawise.ai";
export const HOME_PAGE = process.env.PUBLIC_URL || "/";
